export default __webpack_public_path__ + "static/media/2018-dachshund.6f955579.jpg";